import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { SequenceHero } from '../components/email-sequencing/SequenceHero';
import { SequenceWorkflow } from '../components/email-sequencing/SequenceWorkflow';
import { SequenceProductTour } from '../components/email-sequencing/SequenceProductTour';
import { SequenceFeatures } from '../components/email-sequencing/SequenceFeatures';
import { SequenceDemo } from '../components/email-sequencing/SequenceDemo';
import { SequenceComparison } from '../components/email-sequencing/SequenceComparison';
import { SequencePricing } from '../components/email-sequencing/SequencePricing';
import { SequenceUseCases } from '../components/email-sequencing/SequenceUseCases';
import { SequenceFAQ } from '../components/email-sequencing/SequenceFAQ';
import { SequenceCta } from '../components/email-sequencing/SequenceCta';
import { BookOpenIcon, DatabaseIcon, BuildingIcon, ScaleIcon, BriefcaseIcon } from 'lucide-react';
const sequencingFeatures = [{
  title: 'Doctor contacts database',
  description: 'Access medical practices and physicians.',
  href: 'https://openmart.com/data/doctors',
  cta: 'Explore doctors',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Property management contacts database',
  description: 'Discover property managers with verified details.',
  href: 'https://openmart.com/data/property-management',
  cta: 'Explore property managers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'How to book more meetings using free outreach tools',
  description: 'Proven templates and strategies for outbound email.',
  href: 'https://openmart.com/blogs/how-to-book-more-meetings-using-free-outreach-tools-and-proven-templates',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'How to prospect SMBs without burning your lead list',
  description: 'Smart strategies for sustainable outreach.',
  href: 'https://openmart.com/blogs/how-to-prospect-smbs-without-burning-your-lead-list',
  cta: 'Read guide',
  type: 'Blog',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Clipboard Health case study',
  description: 'How Clipboard Health scales outreach with Openmart.',
  href: 'https://openmart.com/case-study/clipboard-health',
  cta: 'Read case study',
  type: 'Case Study',
  color: 'green' as const,
  icon: BriefcaseIcon
}, {
  title: 'Billion Dollar Market case study',
  description: 'How a sales team used Openmart to break into a billion-dollar local services market.',
  href: 'https://www.openmart.com/case-study/billion-dollar-market',
  cta: 'Read case study',
  type: 'Case Study',
  color: 'green' as const,
  icon: BriefcaseIcon
}, {
  title: 'Openmart vs Apollo',
  description: 'Compare coverage, accuracy, and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-apollo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}];
export function EmailSequencing() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6361">
      <Navbar data-id="element-6362" />
      <main data-id="element-6363">
        <SequenceHero data-id="element-6364" />
        <TrustBar data-id="element-6365" />
        <SequenceWorkflow data-id="element-6366" />
        <SequenceProductTour data-id="element-6367" />
        <SequenceFeatures data-id="element-6368" />
        <SequenceDemo data-id="element-6369" />
        <SequenceComparison data-id="element-6370" />
        <SequencePricing data-id="element-6371" />
        <SequenceUseCases data-id="element-6372" />
        <SequenceFAQ data-id="element-6373" />
        <RelatedFeatures features={sequencingFeatures} data-id="element-6374" />
        <SequenceCta data-id="element-6375" />
      </main>
      <Footer data-id="element-6376" />
    </div>;
}